import React, { useState } from 'react';

const ChatbotView = () => {
  const AZURE_CHATBOT_URL = "https://nbps-ezephtebhhasead8.centralindia-01.azurewebsites.net/"
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="h-full flex flex-col p-6">
      <div className="flex justify-between items-center mb-0">
        {/* <h1 className="text-2xl font-bold">Customer Support Chatbot</h1> */}
      </div>
      
      <div className="flex-1 bg-white rounded-lg shadow-lg overflow-hidden relative">
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        )}
        <iframe
          src={AZURE_CHATBOT_URL}
          title="Azure Chatbot"
          className="w-full h-full border-none"
          allow="microphone; camera"
          onLoad={() => setIsLoading(false)}
        />
      </div>
    </div>
  );
};

export default ChatbotView;